import React from 'react';
import {
  Icon,
  Menu,
  MenuItem,
  MenuItemLabel,
  Pressable,
} from '@gluestack-ui/themed';
import {
  Trash2,
  ArrowUp,
  ArrowDown,
  MoreVertical,
} from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

interface TaskItemOptionsProps {
  readonly: boolean;
  isFirstOfLevel: boolean;
  isLastOfLevel: boolean;
  operations: {
    onMoveUp: () => void;
    onMoveDown: () => void;
    onDelete: () => void;
  };
}

const TaskItemOptions: React.FC<TaskItemOptionsProps> = ({
  readonly,
  isFirstOfLevel,
  isLastOfLevel,
  operations,
}) => {
  const { t } = useTranslation();

  return (
    <Menu
      placement="right top"
      trigger={({ ...triggerProps }) => (
        <Pressable p="$1" borderRadius="$full" $hover={{ bg: '$bgHover' }} {...triggerProps}>
          <Icon as={MoreVertical} size="sm" color="$textSubtle" />
        </Pressable>
      )}
    >
      <MenuItem
        key="move-up"
        textValue="Move Up"
        disabled={readonly || isFirstOfLevel}
        onPress={operations.onMoveUp}
      >
        <Icon as={ArrowUp} size="sm" mr="$2" color="$textSubtle" />
        <MenuItemLabel size="sm">
          {t('lecturer.moduleEditor.taskEditor.buttons.moveUp')}
        </MenuItemLabel>
      </MenuItem>
      <MenuItem
        key="move-down"
        textValue="Move Down"
        disabled={readonly || isLastOfLevel}
        onPress={operations.onMoveDown}
      >
        <Icon as={ArrowDown} size="sm" mr="$2" color="$textSubtle" />
        <MenuItemLabel size="sm">
          {t('lecturer.moduleEditor.taskEditor.buttons.moveDown')}
        </MenuItemLabel>
      </MenuItem>
      <MenuItem
        key="delete"
        textValue="Delete"
        disabled={readonly}
        onPress={operations.onDelete}
      >
        <Icon as={Trash2} size="sm" mr="$2" color="$statusError" />
        <MenuItemLabel size="sm" color="$statusError">
          {t('lecturer.moduleEditor.taskEditor.buttons.delete')}
        </MenuItemLabel>
      </MenuItem>
    </Menu>
  );
};

export default TaskItemOptions;
